module.exports = __webpack_public_path__ + "static/media/LeadersBlack.52d21d97.svg";